import React, { useState, useEffect } from "react";
import "./AlertBox.css";

export default function AlertBox({ show, message, type = "info", onClose }) {
  if (!show) return null;

  const safeMessage = typeof message === "string" ? message : JSON.stringify(message);

  return (
    <div className={`alert-box alert-${type}`}>
      <span>{safeMessage}</span>
      <button className="close-btn" onClick={onClose || (() => {})}>
        &times;
      </button>
    </div>
  );
}
